import { axiosBackEndInstance } from '../Axios';
import { END_POINT_USER, END_POINT_AUTH_REGISTER, END_POINT_ACCOUNT_PASSWORD } from '../Axios/ENDPOINTS';
import { notification } from 'antd';
import { useErrorHandling } from '../hooks/useErrorHandling';
import { useGetUsers } from './useGetUsers';

export interface User{
  id: number,
  username: string,
  first_name: string,
  last_name: string,
  role: string
}

export const useUsers= () => {

    const {errorHandling} = useErrorHandling()
    const { mutate } = useGetUsers()

    // const getUser = async ():Promise<User> =>{
    //   try{
    //     const  data = await axiosBackEndInstance.post(
    //        `${END_POINT_USER}/${id}`
    //     )
    //   }catch(error){

    //   }
    // }

     
     const createUser = async (
      callback: Function,
      values:{
        username: string,        
        first_name: string,        
        last_name: string, 
        password: string,
        role: string
      }
      
      ): Promise<any> => {      
    try {
      const  data = await axiosBackEndInstance.post(
        END_POINT_AUTH_REGISTER, values
      )
      const status =  errorHandling(data).request.status
      if(status === 200){
        callback()
        mutate()
        notification.success({
          message: 'Éxito', 
          description:'Usuario creado con éxito', 
          placement: 'topRight'
        })
      }
      if(status === 403){
        callback()
        notification.info({
          message: 'Info', 
          description: 'contraseña facil', 
          placement: 'topRight'
        })
      }     
    } catch (newError: any) {
      if(newError?.request?.status === 403){
        callback()
        notification.info({
          message: 'Info',
          description: newError?.response?.data?.detail ? newError.response.data.detail : 'Cree otra contraseña',
          placement: 'topRight'
        });
      }else if(newError?.request?.status === 409){
        notification.info({
          message: 'Info',
          description: 'El nombre de usuario ya existe',
          placement: 'topRight'
        });
      }
      else{
        notification.error({
          message: 'Error', 
          description: 'No fue posible crear el usuario, por favor comuníquese con el administrador', 
          placement: 'topRight'
        }) 
      }
      console.log(newError);
      callback()
           
    }
  };

  const editUser = async (
    callback: Function,
    id: number,
    values:{
      username: string,
      first_name: string,
      last_name: string, 
    }
                            
  ): Promise<void> => {
              
    try {
      const data  = await axiosBackEndInstance.put(
        `${END_POINT_USER}/${id}`, values
      );
      callback()   
      if(data.status === 200 || data.status === 201){
        mutate()
        notification.success({
          message: 'Éxito', 
          description:'Usuario editado con éxito', 
          placement: 'topRight'
        })
      }    
    } catch (newError) {    
      callback()
      let status = errorHandling(newError).request.status
      console.log('Status ' + status);
      console.log(newError);
    }
  };

  const deleteUser = async (
    callback: Function,
    id: number                            
  ): Promise<void> => {
      
    try {
      const data  = await axiosBackEndInstance.delete(
        `${END_POINT_USER}/${id}`, 
      );
      callback()   
      if(data.status === 200){
        mutate()
        notification.success({
          message: 'Éxito', 
          description:'Usuario eliminado con éxito', 
          placement: 'topRight'
        })
      }    
    } catch (newError) {
      console.log(newError);
      callback()
      let status = errorHandling(newError).request.status
    }
  };

  
  const editPassword = async (
    callback: Function,
    values: {
      old_password: string,
      new_password: string
    }
  ): Promise<void> => {
    try {
      const data = await axiosBackEndInstance.put(
        `${END_POINT_ACCOUNT_PASSWORD}?old_password=${values.old_password}&new_password=${values.new_password}`
      );
  
      if (data.status === 200) {
        mutate();
        notification.success({
          message: 'Éxito',
          description: 'Contraseña modificada con éxito',
          placement: 'topRight'
        });
        callback();
      }
    } catch (newError: any) {
      const response = newError?.response;  

    if (response?.status === 401) {
      notification.error({
        message: "Error",
        description: "Las credenciales no son correctas",
        placement: "topRight",
      });  
    } else {
      notification.error({
        message: "Error",
        description: "Hubo un error, por favor cominíquese con el administrador",
        placement: "topRight",
      }); 
    }  
      //callback();
      console.log(newError);
    }
  };
  return {
    editUser,
    createUser,
    deleteUser,
    editPassword
  };
};
